// Copyright (c) 2011-2019 by Curalate, Inc.

import React, { Component } from 'react';
import styled from 'styled-components';

import bvTextLogo from '@images/bv-text.svg';

export interface IContent {
  sectionName: string;
  pageNumbers: string;
}

interface IOwnProps {
  contents: IContent[];
  customTitle?: string;
}

export class ReportTableOfContents extends Component<IOwnProps> {
  public renderSectionsAndPages() {
    const { contents } = this.props;
    const sections = [];

    contents.forEach((content: IContent) => {
      sections.push(
        <SectionInfo>
          <SectionName>{content.sectionName}</SectionName>
          <SectionSeparator />
          <SectionPages>{content.pageNumbers}</SectionPages>
        </SectionInfo>,
      );
    });

    return sections;
  }

  public render() {
    const { customTitle } = this.props;

    return (
      <TableOfContentsContainer>
        <TableOfContentsTitle>
          <h2>{customTitle || 'Table of Contents'}</h2>
        </TableOfContentsTitle>
        <TableOfContentsDetails>
          {this.renderSectionsAndPages()}
        </TableOfContentsDetails>
        <TableOfContentsFooter>
          <BVLogo src={bvTextLogo} />
        </TableOfContentsFooter>
      </TableOfContentsContainer>
    );
  }
}

const TableOfContentsContainer = styled.div`
  width: 100%;
  height: 816px;
  padding: 94px 48px;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
  text-align: center;
`;

const TableOfContentsDetails = styled.div`
  width: 700px;
  display: inline-block;
`;

const TableOfContentsTitle = styled.div`
  color: #868b8f;
  margin-bottom: 30px;
`;

const TableOfContentsFooter = styled.div`
  position: absolute;
  background-color: #ffffff;
  bottom: 108px;
  left: 0;
  width: 100%;
`;

const BVLogo = styled.img`
  width: 180px;
`;

const SectionInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const SectionName = styled.div`
  margin-right: 4px;
`;

const SectionSeparator = styled.div`
  flex-grow: 1;
  position: relative;
  bottom: 4px;
  border-bottom: 2px dotted #868b8f;
`;

const SectionPages = styled.div`
  margin-left: 4px;
`;
